import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

interface ISharePopupProps {
  direction: 'up' | 'down';
  left: number;
  top: number;
}

export const SocialButtonsWrapper = styled.div<ISharePopupProps>`
  position: absolute;
  display: flex;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  z-index: 100;
  background-color: ${theme.color.background.primary};
  box-shadow: 0 0.25em 1em rgba(0, 0, 0, 0.12);
  border-radius: 0.125em;

  transform: ${({ direction }) =>
    direction === 'up' ? 'translateY(-100%)' : 'unset'};
`;

export const WrapperArrowUp = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  left: 0.5em;
  top: -0.5em;
  border-left: 0.5em solid transparent;
  border-right: 0.5em solid transparent;
  border-bottom: 0.5em solid ${theme.color.common.white};
`;

export const WrapperArrowDown = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  left: 0.5em;
  bottom: -0.5em;
  border-left: 0.5em solid transparent;
  border-right: 0.5em solid transparent;
  border-top: 0.5em solid ${theme.color.common.white};
`;

export const SocialButton = styled.a`
  width: 3.25rem;
  height: 2.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-radius: 0.125em;
  background-color: ${theme.color.background.primary};

  &:hover {
    background-color: ${theme.color.background.disabled};
  }
`;
